/**
 * 错误边界
 */

import { Card } from 'antd';
import React from 'react';
import { ReactComponent as SvgError } from '@/assets/images/error.svg';
import { Button } from '@emooa/ui';

export const ErrorComponent = () => (
  <Card className="p-5 m-12">
    <div className="flex">
      <SvgError className="ml-10 h-40" />
      <div className="ml-15 mt-2.5">
        <h3>页面异常，有可能是浏览器缓存导致的，也有可能是网络问题导致的。</h3>
        <p className="color-gray">
          页面加载异常，请尝试刷新此页面，并检查网络是否连接正常。
        </p>
        <Button type="primary" onClick={() => window.location.reload()}>
          刷新
        </Button>
      </div>
    </div>
  </Card>
);

export default class ErrorBoundary extends React.Component<
  { children?: React.ReactNode; fallback?: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return <ErrorComponent />;
    }
    return this.props.children;
  }
}
